import { SaleProduct } from "gen/txn/models_pb"
import { Decimal } from "shared-ts/classes/decimal"
import { UUID } from "shared-ts/classes/uuid"
import { safeConvertQuantityToUoMQuantity } from "shared-ts/libs/product/unitsOfMeasure.helpers"

import {
  TALLY_ENTRY_DENOMINATORS,
  areTallyRowsEqual,
  emptyTallyRow,
  formatTallyMeasurement,
  formatTallyRows,
  isTallyBlank,
  isTallyProduct,
  tallyHasWidth,
  tallyRowTotal,
  tallyTotal,
  validateTallyRows,
} from "features/pos/tally"

import { isLinkedReturn, isReturn } from "./saleProduct"
import { getSaleUomInfo } from "./uom"

export {
  TALLY_ENTRY_DENOMINATORS,
  areTallyRowsEqual,
  emptyTallyRow,
  formatTallyMeasurement,
  formatTallyRows,
  isTallyBlank,
  isTallyProduct,
  tallyHasWidth,
  tallyRowTotal,
  tallyTotal,
  validateTallyRows,
}

export function tallyUomCode(sp: SaleProduct): string | undefined {
  const snapshot = isReturn(sp) ? sp.uomSnapshotReturned : sp.uomSnapshot
  return snapshot?.uomCode
}

export function linkedReturnTallyMaxTotal(
  sp: SaleProduct,
  quantityRemainingBySaleProductId: Record<string, Decimal> | undefined
): Decimal | undefined {
  if (!isLinkedReturn(sp)) {
    return undefined
  }
  const remainingBase =
    quantityRemainingBySaleProductId?.[
      UUID.idString(sp.returnedFromSaleProductId)
    ]
  if (!remainingBase) {
    return undefined
  }
  const { uomId, conversionFactorToBase } = getSaleUomInfo({
    saleProduct: sp,
    usage: "return",
  })
  return uomId
    ? safeConvertQuantityToUoMQuantity(remainingBase, conversionFactorToBase)
    : remainingBase
}
